module.exports = __webpack_public_path__ + "img/TransactionHistory.252b2fb1.png";